import {
  LOW_REPORT,
  PRODUCT_REPORT,
  PRODUCT_EXCEL,
  PURCHASE_EXCEL,
  PURCHASE_REPORT,
  SALES_EXCEL,
  SALES_REPORT,
  STOCK_REPORT,
  VIEW_REPORT,
  productExcel,
  PARTY_REPORT,
  MEDICINE_PURCHASE_REPORT,
  MEDICINE_PURCHASE_EXCEL,
  PRODUCT_BATCH_REPORT,
} from '../actions/Report.action';

const initialState = {
  purchaseReport: '',
  purchaseExcel: '',
  salesReport: '',
  salesExcel: '',
  stockReport: '',
  lowReport: '',
  productReport: '',
  productExcel: '',
  partyReport: '',
  medicinePurchaseReport: '',
  medicinePurchaseExcel: '',
  productBatchReport: '',
};

const reportreducer = (state = initialState, action) => {
  switch (action.type) {
    case PURCHASE_REPORT:
      return { ...state, purchaseReport: action.payload };
    case PURCHASE_EXCEL:
      return { ...state, purchaseExcel: action.payload };
    case SALES_REPORT:
      return { ...state, salesReport: action.payload };
    case SALES_EXCEL:
      return { ...state, salesExcel: action.payload };
    case STOCK_REPORT:
      return { ...state, stockReport: action.payload };
    case LOW_REPORT:
      return { ...state, lowReport: action.payload };
    case PRODUCT_REPORT:
      return { ...state, productReport: action.payload };
    case PRODUCT_EXCEL:
      return { ...state, productExcel: action.payload };
    case PARTY_REPORT:
      return { ...state, partyReport: action.payload?.data || {} };
    case MEDICINE_PURCHASE_REPORT:
      return { ...state, medicinePurchaseReport: action.payload };
    case MEDICINE_PURCHASE_EXCEL:
      return { ...state, medicinePurchaseExcel: action.payload };
    case PRODUCT_BATCH_REPORT:
      return { ...state, productBatchReport: action.payload };
    default:
      return state;
  }
};

export default reportreducer;
